import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-screen px-6 bg-gray-200" }
const _hoisted_2 = { class: "w-full max-w-sm p-6 bg-white rounded-md shadow-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8 h-8 ml-2 text-blue-500",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-gray-700" }, "VueBoard")
], -1)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-700" }, "Email", -1)
const _hoisted_7 = { class: "block mt-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-700" }, "Password", -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between mt-4\"><div><label class=\"inline-flex items-center\"><input type=\"checkbox\" class=\"text-indigo-600 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500\"><span class=\"mx-2 text-sm text-gray-600\">Remember me</span></label></div><div><a class=\"block text-sm text-indigo-700 fontme hover:underline\" href=\"#\">Forgot your password?</a></div></div><div class=\"mt-6\"><button type=\"submit\" class=\"w-full px-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500\"> Sign in </button></div>", 2)

import { ref } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const email = ref("johndoe@mail.com");
const password = ref("@#!@#asdf1231!_!@#");

function login() {
  router.push("/dashboard");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        class: "mt-4",
        onSubmit: _withModifiers(login, ["prevent"])
      }, [
        _createElementVNode("label", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "block w-full mt-1 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("label", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: "block w-full mt-1 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _hoisted_9
      ], 40, _hoisted_4)
    ])
  ]))
}
}

})